import axios from "axios"
import { fetchCsrfToken } from "./csrfToken"

const mutatingMethods = ["post", "put", "patch", "delete"]

axios.interceptors.request.use(async (config) => {
  if (config.method && mutatingMethods.includes(config.method.toLowerCase())) {
    let token: string | undefined

    try {
      token = await fetchCsrfToken()
    } catch {
      // Token refresh failed — send no header so the server rescue returns a
      // structured error (csrf_token_expired) that the client can retry against
    }

    if (token) {
      config.headers["X-CSRF-Token"] = token
    }
  }
  return config
})
